import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { connect } from "react-redux";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Notifications from "@material-ui/icons/Notifications";
import HotTubIcon from "@material-ui/icons/HotTub";
// core components/views for Admin layout
import UserProfile from "../views/UserProfile/UserProfile.js";
import SuperCategory from "../views/CategoryTable/SuperCategory.js";
import MenuEdit from "../views/Vendor/MenuEdit.js";
import CategoryEdit from "../views/Vendor/CategoryEdit.js";
import SubCategoryEdit from "../views/Vendor/SubCategoryEdit.js";
import AddMenu from "../views/Vendor/AddMenu.js";
import Menus from "../views/Vendor/MenuTableList.js";
import AddProduct from "../views/Product/AddProduct.js";
import Products from "../views/Product/ProductTable.js";
import ProductEdit from "../views/Product/ProductEdit.js";
import AddCategory from "../views/Vendor/AddCategory.js";
import AddSubCategory from "../views/Vendor/AddSubCategory.js";
import CategoriesTable from "../views/Vendor/CategoriesTable.js";
import SubCategoriesTable from "../views/Vendor/SubCategoriesTable.js";
import Typography from "../views/Typography/Typography.js";
import Icons from "../views/Icons/Icons.js";
import Maps from "../views/Maps/Maps.js";
// core components
import Navbar from "../components/Navbars/Navbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";
import { pushLocation } from "../store/actions/driver/Driver";

import routes2 from "../routes3.js";

import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/logo.png";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { geolocated } from "react-geolocated";

let ps;

const switchRoutes = (
  <Switch>
    {routes2.map((prop, key) => {
      if (prop.layout === "/driver") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
  </Switch>
);

const useStyles = makeStyles(styles);

function Driver({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const image = bgImage;
  const color = "blue";
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const valueUserLoginType = localStorage.getItem("userLoginType") || "";
  const { isGeolocationAvailable, isGeolocationEnabled, coords } = rest;
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  React.useEffect(() => {
    setInterval(() => {
      pushLocation();
    }, 3000);
  }, [coords]);

  const showLocation = (position) => {
    rest.pushLocation({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    });
  };

  const pushLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showLocation);
    }
  };
  const MenuRoute = {
    path: "/allMenus",
    name: "All Menus",
    rtlName: "قائمة الجدول",
    icon: ListAltIcon,
    component: Menus,
    layout: "/driver",
  };

  const ProductRoute = {
    path: "/products",
    name: "Products",
    rtlName: "ملف تعريفي للمستخدم",
    icon: HotTubIcon,
    component: Products,
    layout: "/driver",
  };
  return (
    <div className={classes.wrapper}>
      {valueUserLoginType !== "driver" ? (window.location.href = "/") : ""}
      <Sidebar
        driver={true}
        routes={[...routes2]}
        logoText={"Grospick Driver"}
        logo={logo}
        image={image}
        style={{ textDecoration: "none" }}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes2}
          style={{ textDecoration: "none", backgroundColor: "#FFF" }}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content} style={{ textDecoration: "none" }}>
            <div
              style={{ textDecoration: "none" }}
              className={classes.container}
            >
              {switchRoutes}
              <Switch>
                {/* <Route exact="true" path="/vendor/dashboard" component={Dashboard} /> */}
                <Route exact="true" path="/driver/allMenus" component={Menus} />
                <Redirect exact path="/driver" to="/driver/driver-dashboard" />
              </Switch>
            </div>
          </div>
        ) : (
          <div className={classes.map} style={{ textDecoration: "none" }}></div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  pushLocation: (location) => dispatch(pushLocation(location)),
});

export default connect(
  null,
  mapDispatchToProps
)(
  geolocated({
    positionOptions: {
      enableHighAccuracy: true,
      maximumAge: 0,
    },
    userDecisionTimeout: 5000,
  })(Driver)
);
